export default "__VITE_ASSET__bfb5dacc__"